import React from 'react'
import { FilterOption } from '../_WMS/FilterComponent'
import { TableColumn } from '../_EOS/GenericTable/types'
import { PositionListInfoDto } from '../../interfaces/Position/Position'
import { PositionAutoCompleter } from './components/PositionAutoCompleter'
import { WarehouseFilterDDL } from '../Almacen'
import {
  createBackendTransformer,
  createDisplayTransformer
} from '../../types/filters'
import { YesNoBadge } from '../YesNoBadge/YesNoBadge'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'positionName',
    label: 'Nombre Posición',
    type: 'custom',
    Component: PositionAutoCompleter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    order: 2,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'custom',
    Component: WarehouseFilterDDL,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    order: 3,
    key: 'zoneId',
    label: 'Zona',
    type: 'precreated'
  },
  {
    order: 4,
    key: 'active',
    label: 'Activo',
    type: 'precreated'
  },
  {
    order: 5,
    key: 'typePositionId',
    label: 'Tipo de posición',
    type: 'precreated'
  },
  {
    order: 6,
    key: 'aisle',
    label: 'Pasillo',
    type: 'text',
    maxLength: 3
  },
  {
    order: 7,
    key: 'column',
    label: 'Columna',
    type: 'text',
    maxLength: 3
  },
  {
    order: 8,
    key: 'level',
    label: 'Nivel',
    type: 'text',
    maxLength: 3
  },
  {
    order: 9,
    key: 'slot',
    label: 'Slot',
    type: 'text',
    maxLength: 3
  },
  {
    order: 10,
    key: 'monoSku',
    label: 'MonoSku',
    type: 'yesornotoption'
  },
  {
    order: 11,
    key: 'monoBatch',
    label: 'MonoLote',
    type: 'yesornotoption'
  },
  {
    order: 12,
    key: 'blockIngress',
    label: 'Bloqueo de Ingreso',
    type: 'yesornotoption'
  },
  {
    order: 13,
    key: 'blockEgress',
    label: 'Bloqueo de Egreso',
    type: 'yesornotoption'
  },
  {
    order: 14,
    key: 'maxCapacityRange',
    label: 'Capacidad Máxima',
    type: 'range',
    rangeConfig: {
      initialKey: 'initialMaxCapacity',
      finalKey: 'finalMaxCapacity',
      initialLabel: 'Capacidad Máxima Desde',
      finalLabel: 'Capacidad Máxima Hasta'
    }
  }
]

export const tableColumns: TableColumn<PositionListInfoDto>[] = [
  { key: 'positionId', title: 'ID', sortable: false },
  { key: 'positionName', title: 'Nombre Posición', sortable: true },
  { key: 'typePositionDescription', title: 'Tipo Posición', sortable: false },
  { key: 'warehouseName', title: 'Almacén', sortable: true },
  { key: 'zoneName', title: 'Zona', sortable: false },
  {
    key: 'active',
    title: 'Activo',
    sortable: false,
    render: (value) => React.createElement(YesNoBadge, { value: value as boolean })
  }
]
